import React from 'react'
import { Recording } from '@Entities/matching/recording-group-details'

interface RecordingUsageProps {
    recordings?: Recording[]
    recordingGroupId: any
}

const RecordingUsage = (props: RecordingUsageProps) => (
    <p className="source-container">
        {props.recordings
            ?.map((rec: any) => rec.usageSource)
            .filter((src: any) => src != null)
            .reduce(
                (prevSrc: any, curSrc: any) => (!prevSrc.length || prevSrc[0] === curSrc ? [curSrc] : ['mixed']),
                []
            )
            .flatMap((src: any) => (src === 'historic' ? ['H'] : src === 'regular' ? ['B'] : ['B', 'H']))
            .map((char: string) => (
                <span key={props.recordingGroupId + char} className="source-char">
                    {char}
                </span>
            ))}
    </p>
)

export default RecordingUsage
